module.exports = __webpack_public_path__ + "img/odontogram.6d578c52.png";